import { BeforeLoadContextParameter } from '@tanstack/react-router'

/**
 * Vehicle authentication
 * @param props
 */
export const vehicleAuth = async (props: BeforeLoadContextParameter<any, any, any>) => {
  const { params, context } = props
  const { id } = params
  const { queryClient, client, authUser } = context

  const vehicle = await queryClient.ensureQueryData({
    queryKey: ['vehicle', 'get', id],
    queryFn: () => client.service('vehicle').get(id)
  })

  const allowedAgencies = authUser?.allowed_agencies.split(',').map((id: string) => parseInt(id))

  if (!allowedAgencies.includes(vehicle.agency_id)) {
    throw new Error('Unauthorized')
  }

}
